import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import UiGroup from "./UiGroup";

/**
 * 申报地海关表单
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormCustomhouse extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 关区名称
     */
    Name?: string;
    /**
     * 关区代码
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
}

/**
 * 申报地海关表单-表单校验
 */
export const DtoFormCustomhouseRules = {
    Name: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "blur",
        },
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    Code: [
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    FullName: [
        {
            max: 12040,
            message: "文本长度不能超过 12040 个字符",
            trigger: "blur",
        },
    ],
}

/**
 * 申报地海关表单-设置项
 */
export const DtoFormCustomhouseMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "Name",
    Label: "关区名称",
    Customize: true,
  },
  {
    Prop: "Code",
    Label: "关区代码",
    Customize: true,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Customize: true,
  },
]
